export const overlaysQueryKey = 'Overlays';
export const generateKeys = {
    itemOverlays: (itemId, purchaseOrderNumber) => [
        overlaysQueryKey,
        'item',
        itemId,
        purchaseOrderNumber,
    ],
};
